import { memo } from 'react';

import { DetailInfoContainer } from 'containers/components/EntityDetailV2';
import { ACTIVITY_TYPE_MARKETING_CAMPAIGN } from 'models/ActivityModel';

import { getMarketingCampaignExecutor } from '../../../utils/marketingCampaignActivity';

const ActivityDetailContainer = memo(({ activity, children, content, icon, noTabs = false }) => {
    const isMarketingCampaign =
        parseInt(activity.ActivityType, 10) === ACTIVITY_TYPE_MARKETING_CAMPAIGN;
    const executor = isMarketingCampaign
        ? getMarketingCampaignExecutor(activity)
        : { id: activity.IdActivityOwner, name: activity.ActivityOwner };
    const hasActivityOwner = executor.id && executor.id !== '-1';

    return (
        <DetailInfoContainer
            avatarId={hasActivityOwner && executor.id}
            avatarName={executor.name}
            content={content}
            icon={icon}
            noTabs={noTabs}
        >
            {children}
        </DetailInfoContainer>
    );
});

ActivityDetailContainer.displayName = 'ActivityDetailContainer';

export default ActivityDetailContainer;
